 <template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">offerte.club sellers platform</h1>
        <h2 class="subtitle">
          Hi, this is our platform for sellers who want to publish deals on offerte.club network.
          <br />We will review your coupon deal and if it is appropriate, we will publish it on our channels, for free.
        </h2>
        <div v-if="!this.user.loggedIn">
          Don't you have access yet? Click the button below to request it
          <div class="columns" style="margin-top: 20px; width: 200px;">
            <div class="column">
              <b-button type="is-primary" @click="$router.push('reqaccess')">Request access</b-button>
            </div>
            <div class="column">
              <b-button outlined type="is-primary" @click="$router.push('login')">Login</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Home",
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      user: "user"
    })
  }
};
</script>
